module.exports = __webpack_public_path__ + "media/images/icon-share-on@3x-907ff315fdf451a742185fc75019cb4d.png";